import { RippleDesignTokens } from '@primeuix/themes/aura/ripple';

export const rippleTokens: RippleDesignTokens = {
  colorScheme: {
    light: {
      root: {
        background: 'rgba(0,0,0,0.1)',
      },
    },
    dark: {
      root: {
        background: 'rgba(255,255,255,0.3)',
      },
    },
  },
};
